module.exports = __webpack_public_path__ + "static/media/CrimsonText-SemiBold.2e429612.ttf";